import {
    NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION,
    NO_SUCH_PROJECT_EXCEPTION,
    NO_SUCH_TASK_EXCEPTION,
    PROJECT_IS_ARCHIVED_EXCEPTION,
    PROJECT_IS_NOT_AVAILABLE_EXCEPTION,
    TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION
} from '../../taskManagement/common/ExceptionsTypes'
import {ErrorsExceptions} from './constants'
import {Exceptions as CommonExceptions} from '../../common/constants'


export function copyTaskRpcErrorHandler(rpcError) {
    rpcError.handleOnExceptions([
        NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION,
        TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION,
        PROJECT_IS_NOT_AVAILABLE_EXCEPTION,
        NO_SUCH_TASK_EXCEPTION,
        NO_SUCH_PROJECT_EXCEPTION,
        PROJECT_IS_ARCHIVED_EXCEPTION,
    ])
}

export function createTaskRpcErrorHandler(rpcError) {
    rpcError.handleOnExceptions([
        ErrorsExceptions.TASK_NAME_DUPLICATE,
        NO_SUCH_PROJECT_EXCEPTION,
        PROJECT_IS_ARCHIVED_EXCEPTION,
        PROJECT_IS_NOT_AVAILABLE_EXCEPTION,
        NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION,
        CommonExceptions.USER_IS_NOT_ASSIGNED_TO_MANAGER_EXCEPTION,
        CommonExceptions.USER_IS_DISABLED_EXCEPTION,
        CommonExceptions.NO_SUCH_USER_EXCEPTION,
        CommonExceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION,
        CommonExceptions.USER_HAS_NO_ACCESS_TO_SCOPE_EXCEPTION
    ])
}



// WEBPACK FOOTER //
// ./web/js/panels/task/utils.js